<template>
  <div class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="top-spacing container column">
      <div
        v-if="visibleReviews?.length > 0"
        style="padding-bottom:0;"
        class="full-width"
      >
        <div class="golf-good-price mb-10">
          <div class="top-post-container mb-10">
            <p class="fw-600 m-0 text-uppercase c-body">
              {{ $t("wap.text147") }}
            </p>
          </div>

          <!-- <p class="c-black-text c-bold-text title-h3 m-0">
            {{ $t("wap.text147") }}
          </p> -->
        </div>
        <div class="filter-container-price mb-20">
          <el-row :gutter="20">
            <el-col :sm="24" :md="12" :lg="8" :xl="8">
              <div @click="isShowDialog = true" class="form-item-search-price">
                <img
                  style="width: 18px;"
                  class="ml-10"
                  :src="bg.icon_address"
                  alt=""
                />
                <div
                  :class="{ 'is-action': keySearch }"
                  style="position: relative;"
                  class="full-width"
                >
                  <el-autocomplete
                    tabindex="-1"
                    ref="noFocusAutocomplete"
                    :value="keySearch"
                    class="full-width el-select-search-price"
                    :trigger-on-focus="false"
                    @focus="preventFocus"
                    placeholder=" "
                  >
                  </el-autocomplete>
                </div>
                <label :class="{ 'label-action': keySearch }" for="name">{{
                  $t("searchByField")
                }}</label>
                <img
                  class="mr-10"
                  v-if="keySearch"
                  :src="bg.icon_closed"
                  @click="handleReset($event)"
                  alt=""
                />
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20">
          <el-col
            v-for="(item, index) in visibleReviews"
            :key="index"
            :xs="24"
            :sm="12"
            :md="8"
            :lg="6"
            :xl="6"
          >
            <card-review-facility
              style="margin-bottom: 15px;"
              class="w-100"
              :object-data="item"
              :title="item?.name"
              :location="item.location"
              :rating="item.rating"
              :reviews_count="item.reviews_count"
              :holes_amount="item.holes_amount"
              :description="item.description"
              :image="item?.images"
              :id="item?.id"
            />
          </el-col>
        </el-row>
      </div>
      <div v-if="visibleReviews?.length > 0" class="mt-20 mb-20 text-center">
        <button-customer
          style="width:120px"
          :styles="{
            fontSize: '12px',
            fontWeight: 500,
            height: '30px',
            borderRadius: '5px',
            padding: '5px 0px'
          }"
          :object-data="{ title: $t('viewMore') }"
          @on-action="loadMore"
        />
      </div>
      <div class="popup">
        <DialogSearchFacility
          @item-facility="handleFacility"
          @close="isShowDialog = false"
          :is-show-dialog="isShowDialog"
          :is-views-price="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CardReviewFacility from "@/components/wapV2/cards/CardReviewFacility.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import { mapGetters, mapActions } from "vuex";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import { getBackGround } from "@/utils/wapAuth";
import ButtonCustomer from "@/components/wapV2/button/index.vue";
import DialogSearchFacility from "../DialogSearchFacility.vue";
export default {
  name: "carousel-facility",
  components: {
    CardReviewFacility,
    MainNavBarWapV2,
    ButtonCustomer,
    DialogSearchFacility
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  created() {
    this.onGetList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["review_facility"]),
    visibleReviews() {
      return this.review_facility.slice(0, this.visibleCount);
    }
  },
  watch: {},

  data() {
    return {
      infoHeader: {
        title: this.$t("wap.text147"),
        isShowHomeIcon: true
      },
      isShowDialog: false,
      keySearch: "",
      visibleCount: 8,
      bg: getBackGround()
    };
  },
  methods: {
    ...mapActions(["set_data_review_facility"]),
    pushRouter(path) {
      return this.$router.push(path);
    },
    loadMore() {
      this.visibleCount += 8;
    },
    preventFocus() {
      this.$refs.noFocusAutocomplete.$el.querySelector("input").blur();
    },
    handleFacility(item) {
      if (item) {
        return this.$router.push(`/san/chi-tiet/${item.value}`);
        // this.formRequest = {
        //   sub_title: item.label,
        //   facility_id: item.value
        // };
      }
    },
    onGetList() {
      if (this.review_facility.length > 0) return;
      ReviewFacility.get_review_facility().then(res => {
        const { error_code, data = [] } = res;
        if (error_code === 0 && data.length > 0) {
          const mapData = data.map(i => {
            const obj = {
              ...i,
              id: i.course_id,
              title: i.name,
              images: i.galleries
                .flatMap(item => item.images?.map(imgObj => String(imgObj.img).replace("http://", "https://")))
                .slice(0, 5)
            };
            return obj;
          });
          this.set_data_review_facility(mapData);
        }
      });
    }
  }
};
</script>

<style></style>

<style scoped lang="scss">
.filter-container-price {
  .form-item-search-price {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border: 0.87px solid v-bind("bg.c_border3");
    border-radius: v-bind("bg.b_radius1");
    height: 48.90697479248047px;
    .is-action {
      padding-top: 10px;
    }
    label {
      position: absolute;
      top: 50%;
      left: 35px;
      transform: translateY(-50%);
      font-size: 12px;
      color: v-bind("bg.c_placeholder") !important;
      transition: all 0.3s ease;
      pointer-events: none; // Không làm ảnh hưởng khi click vào
    }
    .label-action {
      top: 35%;
      font-size: 9px;
    }
  }
}
.top-spacing {
  padding-top: 100px;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  .top-post-container {
    min-width: 200px;
    background: #f0f0f0;
    border-left: 4px solid #111827;
    padding: 8px 15px;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
  }
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}

@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
}
@media screen and (min-width: 0px) and (max-width: 591px) {
  .text-see-more {
    font-size: 10px;
  }
}
</style>
